import * as ajax from '../ajax/ajax'
import {
  CATEGORY_CURRENT_SUBSCRIPTIONS,
  CATEGORY_TOGGLE_PATH
} from './../ajax/sdgOnlinePaths'

const handleResponse = (response) => {
  return {data: response.data};
}

export default class CategorySubscriptionApi {

  static toggleSubscription(categoryId) {
    return ajax.postJson(CATEGORY_TOGGLE_PATH + categoryId).then(handleResponse);
  }

  static getCategorySubscriptions() {
    return ajax.getJson(CATEGORY_CURRENT_SUBSCRIPTIONS).then(handleResponse);
  }

}